// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n8-0";
export var animationContainer = "_n8-1";
export var itemPrice = "_n8-a";
export var itemizedContent = "_n8-9";
export var itemizedHeader = "_n8-7";
export var itemizedRow = "_n8-8";
export var itemizedSection = "_n8-6";
export var modalContent = "_n8-2";
export var orderName = "_n8-3";
export var refundOption = "_n8-4";
export var refundOptionsContainer = "_n8-5";
export var shippingLabel = "_n8-b";
export var totalRow = "_n8-c";